import z from 'zod'

export const tabItems = ['national', 'province', 'city'] as const

/** Coerce region codes from JSON search params (number or quoted string). */
const regionCodeSchema = z.preprocess(value => {
  if (value === null || value === undefined || value === '') {
    return undefined
  }

  if (typeof value === 'number') {
    return String(value)
  }

  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (
      trimmed.length >= 2 &&
      trimmed.startsWith('"') &&
      trimmed.endsWith('"')
    ) {
      try {
        return String(JSON.parse(trimmed))
      } catch {
        return trimmed.slice(1, -1)
      }
    }
    return trimmed
  }

  return value
}, z.string().optional())

export const searchParamsExtWorkerSchema = z.object({
  tab: z
    .string()
    .optional()
    .default('national')
    .transform(val => val as (typeof tabItems)[number]),
  province_code: regionCodeSchema,
  city_code: regionCodeSchema
})

export type SearchParams = z.infer<typeof searchParamsExtWorkerSchema>

export type TabItem = (typeof tabItems)[number]
